import searchIcon from "../../images/search.svg";

const icons = { search: searchIcon };

const IconInput = props => {
  let iconName = props.icon ? props.icon : null;
  let icon = null;

  try {
    icon = icons[iconName];
  } catch (err) {
    console.warn(
      `Provided icon ${iconName} not available in IconInput component`
    );
  }

  let normalProps = { ...props };
  delete normalProps["icon"];

  let style = {};
  if (icon) {
    style = {
      background: `url(${icon}) left no-repeat`,
    };
  }
  if (normalProps.style) {
    style = { ...style, ...normalProps.style };
  }

  return (
    <div className="spot-input">
      <input
        type="text"
        {...normalProps}
        style={style}
        className="icon-input"
      />
    </div>
  );
};

export default IconInput;
